import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reset, getFormValues } from 'redux-form'
import { get } from 'lodash'
import { push } from 'connected-react-router'

import { notification } from 'redux/modules/app'
import { setPaymentMethod } from 'redux/modules/api/payment'
import { participants as participantsApi } from 'redux/modules/api'
import { checkEmail } from 'redux/modules/api/asyncValidations'
import { participantScheme } from 'models'
import config from 'config'

function decorator() {
  return ComposedComponent => {
    @connect(
      state => ({
        ...state.api.participants.registrationOptions,
        participants: state.api.participants,
        localeId: state.app.locale.id,
        formValues: getFormValues('participantRegistration')(state)
      }),
      {
        ...participantsApi,
        notification,
        push,
        reset,
        checkEmail,
        setPaymentMethod
      }
    )
    class Participants extends Component {
      static propTypes = {
        localeId: PropTypes.number.isRequired,
        paymentInitialization: PropTypes.func.isRequired,
        createParticipant: PropTypes.func.isRequired,
        createParticipantUsingAuthCode: PropTypes.func.isRequired,
        getPaymentOptions: PropTypes.func.isRequired,
        notification: PropTypes.func.isRequired,
        checkLeader: PropTypes.func.isRequired,
        checkEmail: PropTypes.func.isRequired,
        reset: PropTypes.func.isRequired,
        push: PropTypes.func.isRequired,
        formValues: PropTypes.object,
        setPaymentMethod: PropTypes.func,
        participants: PropTypes.object.isRequired
      }

      state = {
        leaderId: null
      }

      handleCheckLeader = params => {
        return this.props.checkLeader(params).then(({ body }) => {
          this.setState({ leaderId: (body && body.id) || null })

          return body || false
        })
      }

      handleGetPaymentOptions = params => {
        return this.props.getPaymentOptions(params)
      }

      handleCheckEmail = params =>
        this.props.checkEmail(params).then(({ body }) => body || false)

      handlePaymentInitialization = fields =>
        this.props.paymentInitialization(
          participantScheme(fields, this.props.localeId)
        )

      createParticipantPromise = (fields, authorizationCode, { noSuccessHandler = false } = {}) => {
        const payload = {
          ...fields
        }

        payload.parentEmail = fields.parentEmail || ''

        // If authorizationCode is available, then call createParticipantUsingAuthCode
        // Else create the participant the standard way
        return authorizationCode
          ? this.props.createParticipantUsingAuthCode(authorizationCode, participantScheme(payload, this.props.localeId))
          : this.props.createParticipant(participantScheme(payload, this.props.localeId))
          .then(({ body }) => {
            if (noSuccessHandler) {
              return body
            }

            this.handleCreateSuccess()
          })
          .catch(this.handleError)
      }

      handleParticipantCreate = (fields, { noSuccessHandler = false } = {}) => {
        return this.createParticipantPromise(fields, null, { noSuccessHandler })
      }

      handleParticipantCreateUsingAuthCode = (authorizationCode, fields, { noSuccessHandler = false } = {}) => {
        return this.createParticipantPromise(fields, authorizationCode, { noSuccessHandler })
      }

      handleCreateSuccess = () => {
        const { formValues } = this.props

        this.props.setPaymentMethod(get(formValues, 'paymentType.value'))
        this.props.reset('participantRegistration')
        this.props.push(`${config.publicPath}/register/participant/success`)
        // this.props.setWizardCompleted(route.activeId, true)
        return 'success'
      }

      handleError = err => {
        console.debug('error', err.body.userMessage)
        this.props.notification(err.body.userMessage, 'error')
        throw err
      }

      render() {
        return (
          <ComposedComponent
            {...this.props}
            leaderId={this.state.leaderId}
            onPaymentInitialization={this.handlePaymentInitialization}
            onGetPaymentOptions={this.handleGetPaymentOptions}
            createParticipant={this.handleParticipantCreate}
            createParticipantUsingAuthCode={this.handleParticipantCreateUsingAuthCode}
            checkLeader={this.handleCheckLeader}
            checkEmail={this.handleCheckEmail}
          />
        )
      }
    }
    return Participants
  }
}

export default decorator
